// src/services/inventarioService.js
import api from './api';

// ─── Productos ───────────────────────────────────────────────────────────────

export const inventarioService = {

  // ---------------------------------------------------------------------------
  // PRODUCTOS
  // ---------------------------------------------------------------------------

  async getProductos(params = {}) {
    const query = new URLSearchParams();
    if (params.orden)  query.append('orden',  params.orden);
    if (params.dir)    query.append('dir',    params.dir);
    if (params.limit)  query.append('limit',  params.limit);
    if (params.offset) query.append('offset', params.offset);
    if (params.filtros && Object.keys(params.filtros).length) {
      query.append('filtros', JSON.stringify(params.filtros));
    }
    const qs = query.toString();
    const res = await api.get(`/productos${qs ? '?' + qs : ''}`);
    return res.data;
  },

  async getProductosExportar(tipo = 'todo') {
    const res = await api.get(`/productos/exportar-datos?tipo=${tipo}`);
    return res.data;
  },

  async getProducto(id) {
    const res = await api.get(`/productos/${id}`);
    return res.data;
  },

  async createProducto(data) {
    const res = await api.post('/productos', data);
    return res.data;
  },

  async updateProducto(id, data) {
    const res = await api.put(`/productos/${id}`, data);
    return res.data;
  },

  async deleteProducto(id) {
    const res = await api.delete(`/productos/${id}`);
    return res.data;
  },

  // ---------------------------------------------------------------------------
  // PRECIOS DE PRODUCTOS
  // ---------------------------------------------------------------------------

  async getPrecios(productoId) {
    const res = await api.get(`/productos/${productoId}/precios`);
    return res.data;
  },

  async savePrecios(productoId, precios) {
    const res = await api.post(`/productos/${productoId}/precios`, { precios });
    return res.data;
  },

  async getComponentes(productoId) {
    const res = await api.get(`/productos/${productoId}/componentes`);
    return res.data;
  },

  async saveComponentes(productoId, componentes) {
    const res = await api.post(`/productos/${productoId}/componentes`, { componentes });
    return res.data;
  },

  // ---------------------------------------------------------------------------
  // CATEGORÍAS
  // ---------------------------------------------------------------------------

  async getCategorias() {
    const res = await api.get('/categorias');
    return res.data;
  },

  async createCategoria(data) {
    const res = await api.post('/categorias', data);
    return res.data;
  },

  async updateCategoria(id, data) {
    const res = await api.put(`/categorias/${id}`, data);
    return res.data;
  },

  async deleteCategoria(id) {
    const res = await api.delete(`/categorias/${id}`);
    return res.data;
  },

  // ---------------------------------------------------------------------------
  // MARCAS
  // ---------------------------------------------------------------------------

  async getMarcas() {
    const res = await api.get('/marcas');
    return res.data;
  },

  async createMarca(data) {
    const res = await api.post('/marcas', data);
    return res.data;
  },

  async updateMarca(id, data) {
    const res = await api.put(`/marcas/${id}`, data);
    return res.data;
  },

  async deleteMarca(id) {
    const res = await api.delete(`/marcas/${id}`);
    return res.data;
  },

  // ---------------------------------------------------------------------------
  // UNIDADES DE MEDIDA
  // ---------------------------------------------------------------------------

  async getUnidadesMedida(soloActivas = false) {
    const res = await api.get(`/unidades-medida${soloActivas ? '?activas=1' : ''}`);
    return res.data;
  },

  async createUnidadMedida(data) {
    const res = await api.post('/unidades-medida', data);
    return res.data;
  },

  async updateUnidadMedida(id, data) {
    const res = await api.put(`/unidades-medida/${id}`, data);
    return res.data;
  },

  async deleteUnidadMedida(id) {
    const res = await api.delete(`/unidades-medida/${id}`);
    return res.data;
  },

  // ---------------------------------------------------------------------------
  // ALMACENES
  // ---------------------------------------------------------------------------

  async getAlmacenes() {
    const res = await api.get('/almacenes');
    return res.data;
  },

  async createAlmacen(data) {
    const res = await api.post('/almacenes', data);
    return res.data;
  },

  async updateAlmacen(id, data) {
    const res = await api.put(`/almacenes/${id}`, data);
    return res.data;
  },

  async deleteAlmacen(id) {
    const res = await api.delete(`/almacenes/${id}`);
    return res.data;
  },

  // ---------------------------------------------------------------------------
  // STOCK
  // ---------------------------------------------------------------------------

  async getStock(params = {}) {
    const qs = new URLSearchParams();
    if (params.almacen_id)   qs.append('almacen_id',   params.almacen_id);
    if (params.categoria_id) qs.append('categoria_id', params.categoria_id);
    if (params.busqueda)     qs.append('busqueda',     params.busqueda);
    if (params.bajo_minimo)  qs.append('bajo_minimo',  1);
    if (params.sin_stock)    qs.append('sin_stock',    1);
    if (params.limit)        qs.append('limit',        params.limit);
    if (params.offset)       qs.append('offset',       params.offset);
    const res = await api.get(`/stock${qs.toString() ? '?' + qs.toString() : ''}`);
    return res.data;
  },

  async getMovimientosStock(params = {}) {
    const qs = new URLSearchParams();
    if (params.almacen_id)  qs.append('almacen_id',  params.almacen_id);
    if (params.producto_id) qs.append('producto_id', params.producto_id);
    if (params.origen)      qs.append('origen',      params.origen);
    if (params.fecha_desde) qs.append('fecha_desde', params.fecha_desde);
    if (params.fecha_hasta) qs.append('fecha_hasta', params.fecha_hasta);
    if (params.limit)       qs.append('limit',       params.limit);
    if (params.offset)      qs.append('offset',      params.offset);
    const res = await api.get(`/stock/movimientos${qs.toString() ? '?' + qs.toString() : ''}`);
    return res.data;
  },

  async ajustarStock(data) {
    const res = await api.post('/stock/ajuste', data);
    return res.data;
  },

  async configurarLimitesStock(stockId, data) {
    const res = await api.put(`/stock/${stockId}/limites`, data);
    return res.data;
  },
};
